import React from "react";
import { useApi } from "../hooks/useApi";

/**
 * Select mansione condivisa: legge l'anagrafica unificata (governata dalla
 * normativa + codici in uso su phc_hrdipendentes non ancora censiti).
 */
export default function MansioneSelect({
  value,
  onChange,
  required = false,
  className = "border border-gray-300 rounded px-2 py-1.5 text-sm bg-white",
}) {
  const { data, loading } = useApi("/planning/mansioni");
  const items = data?.items || [];

  return (
    <select
      value={value || ""}
      onChange={(e) => onChange(e.target.value || null)}
      required={required}
      disabled={loading}
      className={className}
    >
      <option value="">— Seleziona mansione —</option>
      {items.map((m) => (
        <option key={m.codice} value={m.codice}>
          {m.nome}
          {!m.governata ? " (non in anagrafica)" : ""}
        </option>
      ))}
    </select>
  );
}
